module.exports = __webpack_public_path__ + "static/media/video.b7a12c25.svg";